// src/utils/NotificationService.js
import { getAuth } from 'firebase/auth';
import { db } from '../Security/firebase-config';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

class NotificationService {
  /** 
   * Write into /users/{uid}/notifications 
   * @param uid target user's UID 
   */
  async notifyForUser(uid, { type, message, payload = {} }) {
    const notifsRef = collection(db, 'users', uid, 'notifications');
    await addDoc(notifsRef, {
      type,
      message,
      payload,
      read: false,
      createdAt: serverTimestamp(),
    });
  }

  /** 
   * Convenience: notify the *current* user 
   */
  async notify({ type, message, payload = {} }) {
    const user = getAuth().currentUser;
    if (!user) return;
    await this.notifyForUser(user.uid, { type, message, payload });
  }
}

const notificationService = new NotificationService();

export default notificationService;
